import { useState, useEffect } from "react";
import { useRouter } from "next/router";

export { RouteGuard };

function RouteGuard({ children }) {
    const router = useRouter();
    const { asPath, isReady, pathname } = router;
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        // on route change start - hide page content by setting authorized to false
        const hideContent = () => setAuthorized(false);
        router.events.on("routeChangeStart", hideContent);

        // unsubscribe from events in useEffect return function
        return () => {
            router.events.off("routeChangeStart", hideContent);
            router.events.off("routeChangeComplete", authCheck);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isReady) {
            // on initial load - run auth check
            authCheck(pathname);

            // on route change complete - run auth check
            router.events.on("routeChangeComplete", authCheck);
        }
    }, [isReady]);

    function authCheck(url) {
        // redirect to login page if accessing a private page and not logged in
        const publicPaths = [
            "/login",
            "/set/[set_id]",
            "/worksheet-preview/[worksheet_id]",
        ];

        // allowed paths for users logged in or not logged in
        const nonAuthPaths = ["/quiz/"];

        const path = url.split("?")[0];

        if (nonAuthPaths.some((v) => url.includes(v))) {
            setAuthorized(true);
        } else if (
            !localStorage.getItem("student") &&
            !publicPaths.includes(path)
        ) {
            setAuthorized(false);
            router.push({
                pathname: "/login",
                query: { returnTo: asPath },
            });
        } else {
            setAuthorized(true);
        }
    }

    return authorized && children;
}
